import React from 'react'
import './game-manage-dropmenu.styles.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClone } from '@fortawesome/free-regular-svg-icons'
import { faBoxArchive, faTrash } from '@fortawesome/free-solid-svg-icons'

const GameManageDropmenu = ({
    active,
    makeGameCopy,
    markAsArchived
}) => {

    return (
        <div className={`game-manage-dropmenu ${active ? 'active' : ''}`}>
            <div className='dropdown-menu'>
                <button 
                    className='g-button text-only menu-item'
                    onClick={() => makeGameCopy()}>
                    <FontAwesomeIcon icon={faClone} />
                    Make a Copy
                </button>
                <button 
                    className='g-button text-only menu-item'
                    onClick={() => markAsArchived()} >
                    <FontAwesomeIcon icon={faBoxArchive} />
                    Archive
                </button>
                <button 
                    className='g-button text-only menu-item disabled'>
                    <FontAwesomeIcon icon={faTrash} />
                    Delete
                </button>
            </div>
        </div>
    )
}

export default GameManageDropmenu